var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentMethod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.179 11.8292C9.99493 12.8273 8.45902 13.4298 6.78069 13.4298C3.03582 13.4298 0 10.4301 0 6.72978C0 3.02948 3.03582 0.0297852 6.78069 0.0297852C8.45902 0.0297852 9.99493 0.632283 11.179 1.63033C12.363 0.632283 13.8989 0.0297852 15.5773 0.0297852C19.3221 0.0297852 22.358 3.02948 22.358 6.72978C22.358 10.4301 19.3221 13.4298 15.5773 13.4298C13.8989 13.4298 12.363 12.8273 11.179 11.8292Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1792 11.8292C12.6371 10.6003 13.5616 8.77174 13.5616 6.72978C13.5616 4.68783 12.6371 2.85923 11.1792 1.63032C12.3632 0.632282 13.8992 0.0297852 15.5775 0.0297852C19.3224 0.0297852 22.3582 3.02948 22.3582 6.72978C22.3582 10.4301 19.3224 13.4298 15.5775 13.4298C13.8992 13.4298 12.3632 12.8273 11.1792 11.8292Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1788 11.8292C12.6367 10.6003 13.5611 8.77175 13.5611 6.72981C13.5611 4.68787 12.6367 2.85927 11.1788 1.63037C9.72084 2.85927 8.79639 4.68787 8.79639 6.72981C8.79639 8.77175 9.72084 10.6003 11.1788 11.8292Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment-method.a605bb7d1c4b0179bdd2b67e23388799.svg";
export { ForwardRef as ReactComponent };